export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// /home/apa/domains/apa.plug-in.es/public_html/wp-content/themes/templatePLG/node_modules/swiper/esm/components/core/translate/minTranslate.js
// module id = 111
// module chunks = 0